<template>
<div>
  <v-menu v-model='menu' >
    <template v-slot:activator="{ on }">
    <v-btn v-on='on' slot='activator' flat >
      <v-icon>keyboard_arrow_down</v-icon>
      Share a form
    </v-btn>
    </template>
    <form-list :relationship-id="relationshipId" @selected="setSelectedForm" />
    <!-- <v-list dense subheader class='pa-0' >
      <v-subheader class='overline' >Forms</v-subheader>
      <v-divider ></v-divider>
      <template v-if='request.loading'  >
        <center>
          <v-progress-circular color="amber" indeterminate width='2' class='ma-4' ></v-progress-circular ><br/>
          <small>loading forms</small>
        </center>
      </template>
      <template v-else >
        <v-list-tile v-for='form in forms'
          @click='setSelectedForm(form)'
          :key='form.id' >
          <v-list-tile-content>
            <v-list-tile-title>
              {{form.linked_form.title}}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if='forms && forms.length === 0' >
          <v-list-tile-content>
            <v-list-tile-title>
              No linked forms found
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list> -->
  </v-menu>
<v-dialog v-model='showShare' width='420' :fullscreen='$vuetify.breakpoint.xs' >
    <v-toolbar dense flat dark :color="themeColor" >
      <v-spacer></v-spacer>
      <v-btn @click='showShare=false' icon ><v-icon>close</v-icon></v-btn>
    </v-toolbar>
    <share-card v-if='links && links.length > 0' :links='links' ></share-card>
  </v-dialog>
</div>
</template>
<script>
import FormList from '@/components/lists/FormList.vue'
export default {
  name: 'ShareForm',
  components: { FormList },
  props: {
    relationshipId: { required: true }
  },
  data () {
    return {
      showShare: false,
      menu: false,
      selectedForm: null,
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/forms',
        params: {is_linked: 'true'},
        result: []
      }
    }
  },
  watch: {
    menu () {
      if (this.menu === true) { this.get() }
    }
  },
  computed: {
    forms () {
      return this.request.result
    },
    links () {
      let links = []
      if (this.selectedForm) {
        let linkedForm = this.selectedForm.linked_form
        if (linkedForm) {
          links.push({
            title: linkedForm.title,
            text: linkedForm.description,
            // url: linkedForm.url + '?relationship_id=' + this.relationship_id
            url: this.selectedForm.url + '?relationship_id=' + this.relationshipId
          })
        }
      }
      return links
    }
  },
  methods: {
    get () {
      return this.$request('get', this.request)
    },
    setSelectedForm (form) {
      this.selectedForm = form
      let options = {links: this.links}
      this.launchShareDialog(options)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ShareForm.vue?48705c12